function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityNoParkingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03 25.97V6.445l5.897 5.897v11.7h3v-5.08h2.702c.289 0 .564-.04.839-.08l8.089 8.09H6.03c-.552 0-1-.45-1-1zM26.97 6.03v19.526l-7.414-7.415c1.515-.931 2.494-2.575 2.494-4.521 0-3.02-2.341-5.321-5.421-5.321h-5.703v1.214L6.446 5.03H25.97c.552 0 1 .449 1 1zm-9.591 9.933l-3.452-3.45V11.1h2.5c1.38 0 2.42 1.08 2.42 2.5 0 1.08-.595 1.982-1.468 2.364zm-3.452-.622l.82.819h-.82v-.82zM25.97 3.03H6.03c-1.654 0-3 1.346-3 3v19.94c0 1.655 1.346 3 3 3h19.94c1.656 0 3-1.345 3-3V6.03c0-1.654-1.344-3-3-3z",
    fill: props.color
  }));
}

export default SvgIconFacilityNoParkingFilled;